import React, { useEffect, useState } from "react";
import { Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Image } from "react-bootstrap";
import editIcon from "../../../assets/icons/EditIcon.svg"
import xclose from "../../../assets/icons/x-close.svg";
import ConfirmAlertModal from "../../common/confirmAlertModal";
import Alert from "../../common/Alert";
import Loader from "../../../assets/loader.gif";
import SearchSelect from "../../common/SearchSelect";
import InputBox from "../../common/InputBox";
import { addEnquiryMaster, editEnquiryMaster, getDealerMasterData, getMasterData } from "../../../services/enquiryMaster-service";
import _ from "lodash";
import WariningAlertModal from "../../common/WariningAlertModal";
import OrderLostMaster from "./OrderLostMaster";
import MultiSearchSelect from "../../common/multiSelect";
import DiscountAdd from "./DiscountAdd";
import AddTimelineMaster from "./AddTimelineMaster";
import discountIcon from "../../../assets/icons/DiscountSanction.svg";
import timelineIcon from "../../../assets/icons/PreOrderTimeline.svg";
import orderBookingIcon from "../../../assets/icons/TransactionsGray.svg";
import { getSalesUser } from "../../../services/discount-services";
import { useNavigate } from "react-router-dom";

export default function AddEnquiryMaster(props) {
  console.log("the props", props.rowdata);
  const navigate = useNavigate();

  const formName = "Enquiry";
  const EnquiryID = props.rowdata.ID
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [mandatoryFields, setMandatoryFields] = useState([]);
  const [masterData, setMasterData] = useState([]);
  const [dealerData, setDealerData] = useState([]);
  const [waringMessage, setWaringMessage] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [showOrderLost, setShowOrderLost] = useState(false)
  const [showDiscountAdd, setShowDiscountAdd] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [action, setAction] = useState(props.action)
  const [showAll, setShowAll] = useState({ PG: false, Competitor: false });
  const [showTimelineMaster, setShowTimelineMaster] = useState(false);

  const [dealerEmail, setDealerEmail] = useState(props.action === "Add" ? JSON.parse(sessionStorage.getItem('UserData')).UserData.field_4 : props.rowdata.DealerUserEmail);
  const [salesuser, setSalesuser] = useState([])
  const initialData = props.action === "Add" ? {
    company_code: undefined,
    enable: "Active",
    Title: "",
    AccountName: "",
    EnquiryStatus: "",
    EnquiryType: "",
    Enquirysource: "",
    SSGTerritory: "",
    DeliveryLocation: "",
    PG: "",
    Segment: "",
    Probability: "",
    ExpectedRevenue_x0028_inlakhs_x0: "",
    //TargetVC_x0025_: "",
    ExpectedCloseDate: "",
    Primarycontactemail: "",
    Primarycontactmobile: "",
    Nextcontactdate: "",
    Nextstep: "",
    EnquiryNumber: "",
    Competitor: "",
    Government: "",
    TypeofBid: "",
    DealerUserName: JSON.parse(sessionStorage.getItem('UserData')).UserData.field_2,
    CompetitorName_x0028_ifOrderLost: "",
    AssignedtoId: ""
  } : props.rowdata;

  const [formValues, setFormValues] = useState(initialData);
  const [resultData, setResultData] = useState({})

  const DealerUserNameOptions = dealerData.map((dealer) => (
    <option key={dealer.field_2} value={dealer.field_2}>
      {dealer.field_2}
    </option>
  ));

  const getDropDownOptions = (title) => {
    return masterData.filter((Type) => Type.title === title).flatMap((Type) => Type.value.split(','))
      // .filter((value) => !(action === 'Add' && value === 'Order lost'))
      .map((value) => (
        <option key={value} value={value}>
          {value}
        </option>
      ));
  };

  const dropdownOpen = salesuser.map((item) => (
    <option key={item.field_1} value={item.SalespersonId}>
      {item.field_1}
    </option>
  ));

  const pgOption = []
  masterData.filter((Type) => Type.title === "PG").flatMap((Type) => Type.value.split(',')).map((value) => {
    pgOption.push(value)
    return (
      <option key={value} value={value}>
        {value}
      </option>
    )
  });

  const CompetitorOption = []
  masterData.filter((Type) => Type.title === "Competitor").flatMap((Type) => Type.value.split(',')).map((value) => {
    CompetitorOption.push(value)
    return (
      <option key={value} value={value}>
        {value}
      </option>
    )
  });

  const fetchData = async () => {
    try {
      const delearData = await getDealerMasterData();
      setDealerData(delearData.data)

      const values = await getMasterData();
      console.log("The value ", values)
      setMasterData(values.data.map((item) => ({ title: item.Title, value: item.Value })));

      const result = await getSalesUser();
      setSalesuser(result.data.map((item) => ({ field_1: item.field_1, SalespersonId: item.SalespersonId })));

    } catch (error) {
      console.error("error in catch", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "DealerUserName") {
      const selectedDealer = dealerData.find((dealer) => dealer.field_2 === value);
      if (selectedDealer) {
        setDealerEmail(selectedDealer.field_4);
      }
    }

    setFormValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));


    if (name === "Government" && value === "No") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        TypeofBid: "",
      }));
      setFormValues((prevValues) => ({
        ...prevValues,
        TypeofBid: "",
      }));
    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = {
        ID: props.rowdata.ID,
        Enquiry_Name: formValues.Title,
        Account_Name: formValues.AccountName,
        EnquiryStatus: formValues.EnquiryStatus,
        Enquiry_Type: formValues.EnquiryType,
        Enquiry_Source: formValues.Enquirysource,
        Branch: formValues.SSGTerritory,
        Delivery_Location: formValues.DeliveryLocation,
        Dealer_Code: JSON.parse(sessionStorage.getItem('UserData')).UserData.Title,
        PG: formValues.PG ? ('results' in formValues.PG ? formValues.PG.results : formValues.PG) : "",
        Segment: formValues.Segment,
        Win_Probability: formValues.Probability,
        Expected_Revenue: formValues.ExpectedRevenue_x0028_inlakhs_x0 ? String(formValues.ExpectedRevenue_x0028_inlakhs_x0) : "",
        //TargetVC: formValues.TargetVC_x0025_ ? String(formValues.TargetVC_x0025_) : "",
        Expected_Close_Date: formValues.ExpectedCloseDate,
        Primary_Contact_Email: formValues.Primarycontactemail,
        Primary_Contact_Mobile: formValues.Primarycontactmobile,
        Next_Contact_Date: formValues.Nextcontactdate,
        Next_Step: formValues.Nextstep,
        EnquiryNumber: formValues.EnquiryNumber,
        Competitor: formValues.Competitor ? ('results' in formValues.Competitor ? formValues.Competitor.results : formValues.Competitor) : "",
        Government: formValues.Government,
        Gem: formValues.TypeofBid,
        Dealer_Name: formValues.DealerUserName,
        Dealer_Email: dealerEmail,
        Remarks: formValues.CompetitorName_x0028_ifOrderLost,
        AssignedtoId: formValues.AssignedtoId
      };

      if (action === "Add") {
        await addEnquiryMaster(data)
          .then((result) => {
            setLoading(false)
            Alert("success", result.message);
            setResultData(result.data)

            if (result.data.EnquiryStatus == "Order lost") {
              setShowOrderLost(true)
            }
            else {
              props.setReload(true);
              setShow(false);
              props.onHide();
            }
          })
          .catch((error) => {
            setShow(false);
            setLoading(false);
            Alert("error", error?.data?.message || "An unexpected error occurred.");
          });
      }
      else if (action === "Edit") {
        await editEnquiryMaster(data)
          .then((result) => {
            setLoading(false)
            Alert("success", result.message);
            setResultData(data)

            if (data.EnquiryStatus == "Order lost") {
              setShowOrderLost(true)
            }
            else {
              props.setReload(true);
              setShow(false);
              props.onHide();
            }
          })
          .catch((error) => {
            setLoading(false);
            setShow(false);
            Alert("error", error?.data?.message || "An unexpected error occurred.");
          });
      }
    } catch (err) {
      Alert("error", err.message);
    }
  };

  const resetForm = () => {
    setErrors("");
    if (action === "Add") {
      setDealerEmail(props.action === "Add" ? JSON.parse(sessionStorage.getItem('UserData')).UserData.field_4 : props.rowdata.DealerUserEmail)
      setFormValues((prevState) => ({
        ...prevState,
        Title: "",
        AccountName: "",
        EnquiryStatus: "",
        EnquiryType: "",
        Enquirysource: "",
        SSGTerritory: "",
        DeliveryLocation: "",
        PG: "",
        Segment: "",
        Probability: "",
        ExpectedRevenue_x0028_inlakhs_x0: "",
        TargetVC_x0025_: "",
        ExpectedCloseDate: "",
        Primarycontactemail: "",
        Primarycontactmobile: "",
        Nextcontactdate: "",
        Nextstep: "",
        EnquiryNumber: "",
        Competitor: "",
        Government: "",
        TypeofBid: "",
        DealerUserName: JSON.parse(sessionStorage.getItem('UserData')).UserData.field_2,
        CompetitorName_x0028_ifOrderLost: "",
        AssignedtoId: ""
      }));
    } else if (action === "Edit") {
      setFormValues(props.rowdata);
    }
  };

  const handleCloseConf = () => {
    setShow(false);
  };
  const handleCloseWarningConf = () => {
    setShowWarning(false);
  };
  const handleOrderCloseConf = () => {
    setShowOrderLost(false)
  }

  const handleDiscountAdd = () => {
    setShowDiscountAdd(true);
  };

  const handleDiscountClose = () => {
    setShowDiscountAdd(false);
  };

  const checkUpdates = async (e) => {
    e.preventDefault();
    // if (!_.isEqual(initialData, formValues)) {
    //   setShowWarning(true);
    //   setWaringMessage(
    //     "There are unsaved changes, are you sure you want to exit"
    //   );
    // } else {
    props.onHide();

    // }
  };

  const changeMode = () => {
    setIsEditMode(true);
    setAction("Edit")
  };

  const handleToggleShowAll = (name) => {
    setShowAll((prevShowAll) => ({
      ...prevShowAll,
      [name]: !prevShowAll[name],
    }));
  };

  return (
    <>
      {loading && (
        <div className="loader-box">
          {" "}
          <img src={Loader} alt="Loading" className="newloader"></img>{" "}
        </div>
      )}

      {show && <ConfirmAlertModal
        action={action}
        handleYes={handleAdd}
        formName={formName}
        show={show}
        handleClose={handleCloseConf}
      />}
      {showWarning && <WariningAlertModal
        action={action}
        handleYes={props.onHide}
        formName={formName}
        show={showWarning}
        handleClose={handleCloseWarningConf}
        waringMessage={waringMessage}
      />}
      {showOrderLost && <OrderLostMaster
        result={resultData}
        show={showOrderLost}
        handleClose={handleOrderCloseConf}
        reload={props.setReload}
        showForm={setShow}
        hideForm={props.onHide}
      />}
      {showDiscountAdd && <DiscountAdd
        show={showDiscountAdd}
        onHide={handleDiscountClose}
        enquiryData={formValues}
        EnquiryID={EnquiryID}
        hideForm={props.onHide}
      />}
      {showTimelineMaster && <AddTimelineMaster
        show={showTimelineMaster}
        onHide={() => setShowTimelineMaster(false)}
        enquiryData={formValues}
        action={'Add'}
        onTimelineSuccess={() => {
          setShowTimelineMaster(false);
          props.onHide();
        }}
      />}

      <Modal
        {...props}
        size="lg"
        backdrop="static"
        className={`ProjectModal ${show || showWarning ? "lower-z-index" : ""}`}
      >
        <Modal.Header>
          <Modal.Title>
            {props.action === "Add" ? "Add new enquiry" : isEditMode ? "Edit enquiry" : (
              <> View enquiry {!isEditMode && props.rowdata.EnquiryStatus !== "Order lost" && (

                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip className="custom-tooltip">Edit</Tooltip>}
                >
                  <Image className="edit-icon-form" onClick={() => changeMode()} src={editIcon} />
                </OverlayTrigger>
              )}
              </>)}
          </Modal.Title>
          <div className="header-actions">
            {(action === "View") && props.rowdata.EnquiryStatus !== "Order lost" && (
              <>
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip className="custom-tooltip">Discount Sanction</Tooltip>}
                >
                  <img
                    src={discountIcon}
                    alt="arrow"
                    className="refresh-icon"
                    onClick={handleDiscountAdd}
                  />
                </OverlayTrigger>

                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip className="custom-tooltip">Pre-Order Timeline</Tooltip>}
                >
                  <img
                    src={timelineIcon}
                    alt="arrow"
                    className="refresh-icon"
                    onClick={() => setShowTimelineMaster(true)}
                  />
                </OverlayTrigger>
              </>
            )}
          </div>
          <Image src={xclose} onClick={checkUpdates} ></Image>
        </Modal.Header>
        <Modal.Body className="">
          <div className="mandatory-note">* Mandatory fields</div>
          <div>
            <Form onSubmit={handleAdd}>
              <div className="scrollForm">
                <div className="form-right-adjust">

                  <Row className="modal-row add-edit-form">
                    <InputBox
                      type="text"
                      name="Title"
                      id="Title"
                      value={formValues.Title}
                      label="Enquiry Name*"
                      fieldName="Enquiry Name"
                      onChange={handleInputChange}
                      maxLength={100}
                      placeholder=""
                      required
                      mandatoryFields={mandatoryFields}
                      setMandatoryFields={setMandatoryFields}
                      setError={setErrors}
                      error={errors.Title}
                      hint="Enter enquiry name"
                      isAlphanumericWithSpecialChars
                      readOnly={action === "View" ? true : false}
                    />

                    <InputBox
                      type="text"
                      name="AccountName"
                      id="AccountName"
                      label="Account Name*"
                      value={formValues.AccountName}
                      onChange={handleInputChange}
                      fieldName="Account Name"
                      required
                      maxLength={100}
                      setError={setErrors}
                      mandatoryFields={mandatoryFields}
                      setMandatoryFields={setMandatoryFields}
                      error={errors.AccountName}
                      hint="Enter account name"
                      isAlphanumericWithSpecialChars
                      readOnly={action === "View" ? true : false}
                    />

                    <SearchSelect
                      name="EnquiryStatus"
                      value={formValues.EnquiryStatus}
                      option={getDropDownOptions("Enquiry Status")}
                      label="Enquiry Status*"
                      id="EnquiryStatus"
                      fieldName="Enquiry Status"
                      onChange={handleInputChange}
                      placeholder=""
                      required
                      mandatoryFields={mandatoryFields}
                      setMandatoryFields={setMandatoryFields}
                      setError={setErrors}
                      error={errors.EnquiryStatus}
                      hint="Enter enquiry status"
                      isAlphaNumericSpace
                      readOnly={action === "View" ? true : false}
                    />
                  </Row>

                  <Row className="modal-row add-edit-form">
                    <SearchSelect
                      name="EnquiryType"
                      value={formValues.EnquiryType}
                      option={getDropDownOptions("Enquiry type")}
                      label="Enquiry Type"
                      id="EnquiryType"
                      fieldName="Enquiry Type"
                      onChange={handleInputChange}
                      placeholder=""
                      setError={setErrors}
                      error={errors.EnquiryType}
                      hint="Enter enquiry type"
                      isAplhaNumericWithSpecialChars
                      readOnly={action === "View" ? true : false}
                    />

                    <SearchSelect
                      name="Enquirysource"
                      value={formValues.Enquirysource}
                      option={getDropDownOptions("Enquiry source")}
                      label="Enquiry Source*"
                      id="Enquirysource"
                      fieldName="Enquiry Source"
                      onChange={handleInputChange}
                      placeholder=""
                      required
                      mandatoryFields={mandatoryFields}
                      setMandatoryFields={setMandatoryFields}
                      setError={setErrors}
                      error={errors.Enquirysource}
                      hint="Enter enquiry source"
                      isAplhaNumericWithSpecialChars
                      readOnly={action === "View" ? true : false}
                    />

                    <SearchSelect
                      name="SSGTerritory"
                      value={formValues.SSGTerritory}
                      option={getDropDownOptions("Sales Branch List")}
                      label="Branch*"
                      id="SSGTerritory"
                      fieldName="Branch"
                      onChange={handleInputChange}
                      placeholder=""
                      required
                      mandatoryFields={mandatoryFields}
                      setMandatoryFields={setMandatoryFields}
                      setError={setErrors}
                      error={errors.SSGTerritory}
                      hint="Enter branch"
                      isAplhaNumericWithSpecialChars
                      readOnly={action === "View" ? true : false}
                    />
                  </Row>

                  <Row className="modal-row add-edit-form ">
                    <InputBox
                      type="text"
                      name="DeliveryLocation"
                      id="DeliveryLocation"
                      label="Delivery Location"
                      value={formValues.DeliveryLocation}
                      onChange={handleInputChange}
                      fieldName="Delivery Location"
                      setError={setErrors}
                      error={errors.DeliveryLocation}
                      hint="Enter delivery location"
                      isAlphanumericWithSpecialChars
                      maxLength={500}
                      readOnly={action === "View" ? true : false}
                    />

                    <InputBox
                      type="text"
                      name="Dealer_Code"
                      id="Dealer_Code"
                      label="Dealer Code"
                      maxLength={100}
                      value={JSON.parse(sessionStorage.getItem('UserData')).UserData.Title}
                      onChange={handleInputChange}
                      placeholder=""
                      fieldName="Dealer Name"
                      setError={setErrors}
                      error={errors.Dealer_Code}
                      hint="Enter dealer name"
                      isAlphanumericWithoutSpace
                      readOnly={action === "View" ? true : false}
                      disabled={action !== "View" ? true : false}
                    />

                    <SearchSelect
                      name="Segment"
                      value={formValues.Segment}
                      option={getDropDownOptions("Segment")}
                      label="Segment*"
                      id="Segment"
                      fieldName="Segment"
                      onChange={handleInputChange}
                      placeholder=""
                      required
                      mandatoryFields={mandatoryFields}
                      setMandatoryFields={setMandatoryFields}
                      setError={setErrors}
                      error={errors.Segment}
                      hint="Enter segment"
                      isAlphanumericWithSpecialChars
                      readOnly={action === "View" ? true : false}
                    />
                  </Row>
                  <Row className="modal-row add-edit-form">
                    {/* <InputBox
                      type="text"
                      name="TargetVC_x0025_"
                      id="TargetVC_x0025_"
                      label="Target VC %"
                      value={formValues.TargetVC_x0025_}
                      onChange={handleInputChange}
                      maxLength={3}
                      fieldName="Target VC %"
                      setError={setErrors}
                      error={errors.TargetVC_x0025_}
                      hint="Enter target vc %"
                      isDecimalNumber
                      readOnly={action === "View" ? true : false}
                    /> */}

                    <SearchSelect
                      name="Probability"
                      value={formValues.Probability}
                      option={getDropDownOptions("Win probability")}
                      label="Win Probability*"
                      id="Probability"
                      fieldName="Win probability"
                      onChange={handleInputChange}
                      placeholder=""
                      required
                      mandatoryFields={mandatoryFields}
                      setMandatoryFields={setMandatoryFields}
                      setError={setErrors}
                      error={errors.Probability}
                      hint="Enter win probability"
                      isAlphanumericWithSpecialChars
                      readOnly={action === "View" ? true : false}
                    />

                    <InputBox
                      type="text"
                      name="ExpectedRevenue_x0028_inlakhs_x0"
                      id="ExpectedRevenue_x0028_inlakhs_x0"
                      label="Expected PO Value In Lakh*"
                      maxLength={10}
                      value={formValues.ExpectedRevenue_x0028_inlakhs_x0}
                      onChange={handleInputChange}
                      placeholder=""
                      fieldName="Expected PO value in lakh"
                      required
                      mandatoryFields={mandatoryFields}
                      setMandatoryFields={setMandatoryFields}
                      setError={setErrors}
                      error={errors.ExpectedRevenue_x0028_inlakhs_x0}
                      hint="Enter expected po value in lakh"
                      isDecimalNumber
                      readOnly={action === "View" ? true : false}
                    />
                  </Row>

                  <Row className="modal-row add-edit-form">
                    <MultiSearchSelect
                      options={pgOption}
                      name="PG"
                      value={formValues.PG && formValues.PG.results ? formValues.PG.results : formValues.PG || []}
                      label="PG"
                      id="PG"
                      onChange={handleInputChange}
                      hint="Enter PG"
                      showAll={showAll.PG}
                      onToggleShowAll={() => handleToggleShowAll('PG')}
                      setError={setErrors}
                      readOnly={action === "View" ? true : false}
                    />

                    <MultiSearchSelect
                      options={CompetitorOption}
                      name="Competitor"
                      value={formValues.Competitor && formValues.Competitor.results ? formValues.Competitor.results : formValues.Competitor || []}
                      label="Competitor"
                      onChange={handleInputChange}
                      hint="Enter Competitor"
                      showAll={showAll.Competitor}
                      onToggleShowAll={() => handleToggleShowAll('Competitor')}
                      setError={setErrors}
                      readOnly={action === "View" ? true : false}
                    />
                  </Row>

                  <Row className="modal-row add-edit-form">
                    <InputBox
                      type="date"
                      name="ExpectedCloseDate"
                      id="ExpectedCloseDate"
                      label="Expected Date Of Closure*"
                      value={formValues.ExpectedCloseDate?.split("T")[0]}
                      onChange={handleInputChange}
                      fieldName="Expected date of closure"
                      required
                      setError={setErrors}
                      mandatoryFields={mandatoryFields}
                      setMandatoryFields={setMandatoryFields}
                      error={errors.ExpectedCloseDate}
                      hint="Enter expected date of closure"
                      isTimeStamp
                      readOnly={action === "View" ? true : false}
                    />

                    <InputBox
                      type="text"
                      name="Primarycontactemail"
                      id="Primarycontactemail"
                      label="Primary Contact Email"
                      maxLength={50}
                      value={formValues.Primarycontactemail}
                      onChange={handleInputChange}
                      placeholder=""
                      fieldName="Primary contact email"
                      setError={setErrors}
                      error={errors.Primarycontactemail}
                      hint="Enter primary contact email"
                      Email
                      readOnly={action === "View" ? true : false}
                    />

                    <InputBox
                      type="text"
                      name="Primarycontactmobile"
                      id="Primarycontactmobile"
                      label="Primary Contact Mobile No"
                      value={formValues.Primarycontactmobile}
                      onChange={handleInputChange}
                      maxLength={20}
                      fieldName="Primary contact mobile no."
                      setError={setErrors}
                      hint="Enter primary contact mobile no."
                      error={errors.Primarycontactmobile}
                      isNumeric
                      readOnly={action === "View" ? true : false}
                    />
                  </Row>

                  <Row className="modal-row add-edit-form">
                    <InputBox
                      type="date"
                      name="Nextcontactdate"
                      id="Nextcontactdate"
                      label="Next Contact Date"
                      value={formValues.Nextcontactdate?.split("T")[0]}
                      onChange={handleInputChange}
                      fieldName="Next contact date"
                      setError={setErrors}
                      error={errors.Nextcontactdate}
                      hint="Enter next contact date"
                      isTimeStamp
                      readOnly={action === "View" ? true : false}
                    />

                    <InputBox
                      type="text"
                      name="Nextstep"
                      id="Nextstep"
                      label="Next Step"
                      value={formValues.Nextstep}
                      onChange={handleInputChange}
                      maxLength={500}
                      fieldName="Next Step"
                      setError={setErrors}
                      error={errors.Nextstep}
                      hint="Enter next step"
                      isAlphanumericWithSpecialChars
                      readOnly={action === "View" ? true : false}
                    />

                    <InputBox
                      type="text"
                      name="EnquiryNumber"
                      id="EnquiryNumber"
                      label="Design Enquiry No"
                      value={formValues.EnquiryNumber}
                      onChange={handleInputChange}
                      maxLength={500}
                      fieldName="Design Enquiry No"
                      setError={setErrors}
                      error={errors.EnquiryNumber}
                      hint="Enter design enquiry no"
                      isAlphanumericWithSpecialChars
                      readOnly={action === "View" ? true : false}
                    />
                  </Row>

                  <Row className="modal-row add-edit-form">
                    <SearchSelect
                      name="DealerUserName"
                      value={formValues.DealerUserName}
                      option={DealerUserNameOptions}
                      label="Assigned To Dealer Name"
                      id="DealerUserName"
                      fieldName="Assigned To Dealer name"
                      onChange={handleInputChange}
                      placeholder=""
                      setError={setErrors}
                      error={errors.DealerUserName}
                      hint="Enter assigned to"
                      isAlphaNumericSpace
                      readOnly={action === "View" ? true : false}
                    />

                    <InputBox
                      type="text"
                      name="DealerUserEmail"
                      id="DealerUserEmail"
                      label="Assigned To Dealer (Email Id)"
                      value={dealerEmail}
                      onChange={handleInputChange}
                      maxLength={10}
                      fieldName="Assigned To Dealer (email id)"
                      setError={setErrors}
                      error={errors.DealerUserEmail}
                      hint="Enter dealer email"
                      isAlphaNumericSpace
                      readOnly={action === "View" ? true : false}
                      disabled={action !== "View" ? true : false}
                    />

                    <SearchSelect
                      name="Government"
                      value={formValues.Government}
                      option={getDropDownOptions("Government")}
                      label="Government*"
                      id="Government"
                      fieldName="Government"
                      onChange={handleInputChange}
                      placeholder=""
                      mandatoryFields={mandatoryFields}
                      setMandatoryFields={setMandatoryFields}
                      required
                      setError={setErrors}
                      error={errors.Government}
                      hint="Enter government"
                      isAlphaNumericSpace
                      readOnly={action === "View" ? true : false}
                    />
                  </Row>

                  <Row className="modal-row add-edit-form">
                    {formValues.Government === "Yes" && <SearchSelect
                      name="TypeofBid"
                      value={formValues.TypeofBid}
                      option={getDropDownOptions("Gem")}
                      label="GEM*"
                      id="TypeofBid"
                      fieldName="GEM"
                      onChange={handleInputChange}
                      placeholder=""
                      mandatoryFields={mandatoryFields}
                      setMandatoryFields={setMandatoryFields}
                      required
                      setError={setErrors}
                      error={errors.TypeofBid}
                      hint="Enter GEM"
                      isAlphaNumericSpace
                      readOnly={action === "View" ? true : false}
                    />
                    }

                    <SearchSelect
                      name="AssignedtoId"
                      value={formValues.AssignedtoId}
                      option={dropdownOpen}
                      label="Sales Manager*"
                      id="AssignedtoId"
                      fieldName="Sales Manager"
                      onChange={handleInputChange}
                      mandatoryFields={mandatoryFields}
                      setMandatoryFields={setMandatoryFields}
                      placeholder="Select Sales Manager"
                      setError={setErrors}
                      error={errors.AssignedtoId}
                      required
                      readOnly={action == 'View' && true}
                    />

                    <div className="CompetitorName_class">
                      <InputBox
                        type="text"
                        name="CompetitorName_x0028_ifOrderLost"
                        id="CompetitorName_x0028_ifOrderLost"
                        label="Remarks"
                        value={formValues.CompetitorName_x0028_ifOrderLost}
                        onChange={handleInputChange}
                        maxLength={500}
                        fieldName="Remarks"
                        setError={setErrors}
                        error={errors.CompetitorName_x0028_ifOrderLost}
                        hint="Enter remarks"
                        isAlphanumericWithSpecialChars
                        readOnly={action === "View" ? true : false}
                      />
                    </div>
                  </Row>
                </div>
              </div>

              <Modal.Footer className="justify-content-center">
                {
                  action !== "View" &&
                  <Button variant="primary" type="submit" className="modal-btn-sub"
                    disabled={
                      action === "View" ||
                      !formValues.Title || !formValues.AccountName || !formValues.EnquiryStatus || !formValues.Segment || !formValues.Enquirysource || !formValues.SSGTerritory || !formValues.ExpectedRevenue_x0028_inlakhs_x0 || !formValues.Probability || !formValues.ExpectedCloseDate || !formValues.Government || !formValues.AssignedtoId || (formValues.Government === "Yes" && !formValues.TypeofBid) ||
                      (action === "Edit" && _.isEqual(props.rowdata, formValues))
                      || (errors.Title && errors.Title != "")
                      || (errors.AccountName && errors.AccountName != "")
                      || (errors.EnquiryStatus && errors.EnquiryStatus != "")
                      || (errors.EnquiryType && errors.EnquiryType != "")
                      || (errors.Enquirysource && errors.Enquirysource != "")
                      || (errors.SSGTerritory && errors.SSGTerritory != "")
                      || (errors.DeliveryLocation && errors.DeliveryLocation != "")
                      || (errors.PG && errors.PG != "")
                      || (errors.Segment && errors.Segment != "")
                      || (errors.Probability && errors.Probability != "")
                      || (errors.ExpectedRevenue_x0028_inlakhs_x0 && errors.ExpectedRevenue_x0028_inlakhs_x0 != "")
                      || (errors.ExpectedCloseDate && errors.ExpectedCloseDate != "")
                      || (errors.Primarycontactemail && errors.Primarycontactemail != "")
                      || (errors.Primarycontactmobile && errors.Primarycontactmobile != "")
                      || (errors.Nextcontactdate && errors.Nextcontactdate != "")
                      || (errors.Nextstep && errors.Nextstep != "")
                      || (errors.EnquiryNumber && errors.EnquiryNumber != "")
                      || (errors.Competitor && errors.Competitor != "")
                      || (errors.Government && errors.Government != "")
                      || (errors.TypeofBid && errors.TypeofBid != "")
                      || (errors.DealerUserName && errors.DealerUserName != "")
                      || (errors.DealerUserEmail && errors.DealerUserEmail != "")
                      || (errors.CompetitorName_x0028_ifOrderLost && errors.CompetitorName_x0028_ifOrderLost != "")
                      || (errors.AssignedtoId && errors.AssignedtoId != "")
                    }
                  >
                    {action === "Add" ? "Submit" : "Update"}
                  </Button>
                }
                {action === "View" && props.rowdata.EnquiryStatus !== "Order lost" && (
                  <Button
                    variant="primary"
                    className="modal-btn-sub"
                    style={{minWidth: "fit-content"}}
                    disabled={formValues.EnquiryStatus !== "Order won"}
                    onClick={() => {
                      props.onHide();
                      navigate('/orderbooking', { state: { openAdd: true, enquiryData: formValues } });
                    }}
                  >
                    Order Booking
                  </Button>
                )}
              </Modal.Footer>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
